import { SymbolPool } from '@1x2network/reel_set'
import { slotStore } from '@1x2network/slot-ui'
import { CustomSymbol } from '../CustomSymbol'
import { FeatureValueSymbol, SymbolModel, ValueSymbol } from '../model/SymbolModel'
import { isFeatureValueSymbol, isValueSymbol } from '../types/typeGuards'
import { times } from '../utils/times'

/**
 *
 * Pool constructing symbols specifically for this game
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */
export class CustomSymbolPool extends SymbolPool<CustomSymbol, SymbolModel, SymbolModel> {
    /**
     * Construct  new symbol or return one from the pooled amount
     * @param data symbol data to construct symbol
     * @returns symbol
     */
    createSymbol(data: SymbolModel): CustomSymbol {
        const symbol = super.createSymbol(data)
        const FeatureValueSymbol = isFeatureValueSymbol(data)
        const ValueSymbol = isValueSymbol(data)

        if (!FeatureValueSymbol && !ValueSymbol) {
            symbol.updateTextValue(0)
            return symbol
        }

        if (FeatureValueSymbol) {
            symbol.updateTextValue((data as FeatureValueSymbol).cash.start.currency)
        } else {
            const stake = slotStore.getState().stake.current.currency
            symbol.updateTextValue(times(stake, (data as ValueSymbol).timesStake.end))
        }

        if (ValueSymbol) {
            const sub = slotStore.subscribe(
                (state) => {
                    return state.stake.current.currency
                },
                (state) => {
                    symbol.updateTextValue(times(state, (data as ValueSymbol).timesStake.end))
                },
            )
            symbol.stakeSub = sub
        }

        return symbol
    }
}
